import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const PrivateRouteAdmin = () => {
    const [checking, setChecking] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isCustomer, setIsCustomer] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("user");

        if (!token) {
            setChecking(false);
            setIsAdmin(false);
            setIsCustomer(false);
            return;
        }

        axios.interceptors.request.use((config) => {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });

        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                const profile = res?.data?.data || {};
                setIsAdmin(Boolean(profile.isAdmin));
                setIsCustomer(Boolean(profile.isCustomer));
                if (profile.isAdmin || profile.isCustomer) {
                    localStorage.setItem("profile", JSON.stringify(profile));
                }
            })
            .catch(() => {
                localStorage.removeItem("user");
                localStorage.removeItem("profile");
                localStorage.removeItem("data");
                setIsAdmin(false);
                setIsCustomer(false);
            })
            .finally(() => {
                setChecking(false);
            });
    }, []);

    if (checking) {
        return <div />;
    }

    if (isAdmin) return <Outlet />;
    if (isCustomer) return <Navigate to="/customer" replace />;
    return <Navigate to="/login" replace />;
};

export default PrivateRouteAdmin;
